import React from 'react';
import { Button, Card, Carousel, Col, Row, Typography, Avatar, Layout, Space } from 'antd';
import {
    CheckCircleOutlined,
    CarOutlined,
    HomeOutlined,
    EnvironmentOutlined,
    LoginOutlined,
    MailOutlined,
    PhoneOutlined
} from '@ant-design/icons';
import logoImage from '../img/limo.jpg';
import Image from '../img/car.png';
import { GlobalOutlined, FieldTimeOutlined } from '@ant-design/icons';

import BlogList from '../components/UI/BlogList';

const { Title, Paragraph, Text } = Typography;
const { Header, Footer, Content } = Layout;

const heroImages = [
    'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1470&q=80',
    'https://media.istockphoto.com/id/1490624234/photo/bentley-continental-gt-w12-3-is-parked-near-newly-constructed-appartment-building-side-back.jpg?s=612x612&w=0&k=20&c=go_aq4xF-XxriO-phfMSjOG2P9aaB6XDuJH7FSbahYk=',
    'https://media.istockphoto.com/id/170069081/photo/opening-car-door.jpg?s=612x612&w=0&k=20&c=5YP5K6R4mFtyormHUx31tx0ON3LFBORaqX1h9_eM_po='
];

const testimonials = [
    {
        text: "The limo was spotless and the service was top-tier. I felt like a VIP!",
        name: "Michael Turner",
        avatar: "https://randomuser.me/api/portraits/men/45.jpg"
    },
    {
        text: "Professional and punctual! Will definitely use this service again.",
        name: "Lisa Wong",
        avatar: "https://randomuser.me/api/portraits/women/32.jpg"
    },
    {
        text: "A smooth ride from start to finish. Highly recommended for special events.",
        name: "James Allen",
        avatar: "https://randomuser.me/api/portraits/men/23.jpg"
    }
];

const Limo = () => {
    return (
        <Layout>
            {/* Top Contact Banner */}
            <div>
                {/* Top Strip: Contact Info */}
                <div style={{
                    backgroundColor: '#001f5b',
                    color: '#fff',
                    padding: '6px 40px',
                    fontSize: '0.875rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                }}>
                    <span><strong>Need Help?</strong></span>
                    <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                        <span><PhoneOutlined /> +1470-696-4956</span>
                        <span><MailOutlined />luxurylifelimo@yahoo.com</span>
                    </div>
                </div>

                {/* Bottom Strip: Business Info */}
                <div
                    style={{
                        backgroundColor: '#ffffff',
                        color: '#0d1a3f',
                        padding: '16px 40px',
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        borderBottom: '1px solid #e0e0e0',
                        fontWeight: 500,
                        textAlign: 'center'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '40px',
                            fontSize: '1rem',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <span>Limousine Booking Service</span>

                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <GlobalOutlined /> Atlanta, Georgia, US
                        </span>

                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <FieldTimeOutlined /> Monday to Saturday
                        </span>

                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <FieldTimeOutlined /> 24hrs
                        </span>
                    </div>
                </div>
            </div>

            {/* Header */}
            <Header
                style={{
                    backgroundColor: '#001f5b',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 40px',
                    height: 96  // Increased height
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <img
                        src={logoImage}
                        alt="Luxury Life Limo Logo"
                        style={{
                            height: '80%',        // Responsive to header height
                            maxHeight: 80,         // Prevents it from getting too large
                            objectFit: 'contain'   // Keeps aspect ratio clean
                        }}
                    />
                </div>
                <a href="/login" target="_blank" rel="noopener noreferrer">
                    <Button icon={<LoginOutlined />} type="primary">
                        Login
                    </Button>
                </a>
            </Header>



            <Content>
                {/* Hero Section */}
                <Carousel autoplay effect="fade" dots={false} style={{ height: '100vh', overflow: 'hidden' }}>
                    {heroImages.map((img, index) => (
                        <div key={index}>
                            <div
                                style={{
                                    backgroundImage: `url(${img})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    height: '100vh',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    paddingLeft: '10%',
                                    color: 'white',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    backgroundBlendMode: 'overlay',
                                }}
                            >
                                <div style={{ maxWidth: 600 }}>
                                    <Title style={{ color: 'white', fontSize: '3rem', marginBottom: '1rem' }}>
                                        Premium Limousine and Black Car Services For Every Occasion
                                    </Title>
                                    <Paragraph style={{ color: 'white', fontSize: '1.25rem', marginBottom: '2rem' }}>
                                        Book Your Ride — Experience Elegance and Comfort
                                    </Paragraph>
                                    <a href="/login" target="_blank" rel="noopener noreferrer">
                                        <Button
                                            type="primary"
                                            size="large"
                                            style={{
                                                backgroundColor: 'teal',
                                                borderColor: 'white',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                            }}
                                        >
                                            Book Now
                                        </Button>
                                    </a>

                                    <div style={{
                                        marginTop: '2rem',
                                        textAlign: 'center',
                                        color: '#fff',
                                        padding: '1rem',
                                        borderRadius: '8px',
                                        maxWidth: '600px',
                                        marginInline: 'auto'
                                    }}>
                                        <h3 style={{ marginBottom: '0.5rem' }}>$95 Flat Rate for First 25 Miles</h3>
                                        <p style={{ marginBottom: '0.25rem' }}>• SUV and Sedan hourly rates within Metro Atlanta start at $95/hr.</p>
                                        <p style={{ marginBottom: '0' }}>• Transparent pricing. No surprises.</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                </Carousel>

                {/* About Section */}
                <div style={{ padding: '80px 20px', maxWidth: 1200, margin: '0 auto' }}>
                    <Row gutter={40} align="middle">
                        <Col md={12} sm={24}>
                            <div style={{ paddingRight: 20 }}>
                                <Title level={4} style={{ color: '#faad14', marginBottom: 0 }}>About Us</Title>
                                <Title level={2} style={{ marginBottom: 20 }}>Customized Luxury Transport Services</Title>
                                <Paragraph style={{ fontSize: '1.05rem', lineHeight: 1.7 }}>
                                    At <strong>LuxuryLife Limo</strong>, we specialize in providing personalized and elegant transportation solutions tailored to your specific needs.
                                    Whether you're heading to the airport, planning a wedding, or celebrating a special event, we ensure your ride is safe, stylish, and stress-free.
                                    With a commitment to reliability and excellence, we go the extra mile to make your journey unforgettable.
                                </Paragraph>
                                <Paragraph style={{ fontSize: '1.05rem', lineHeight: 1.7, color: 'teal', fontWeight: 'bold' }}>
                                    Please contact us directly for hourly booking and charter <a href="tel: +1470-696-4956" style={{ color: '#faad14' }}> +1470-696-4956</a>
                                </Paragraph>


                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: 12, columnGap: 16, marginTop: 20 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <CheckCircleOutlined style={{ color: '#faad14' }} />
                                        <Text>Safe and Reliable</Text>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <CheckCircleOutlined style={{ color: '#faad14' }} />
                                        <Text>Personalized Service</Text>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <CheckCircleOutlined style={{ color: '#faad14' }} />
                                        <Text>Luxury and Comfort</Text>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <CheckCircleOutlined style={{ color: '#faad14' }} />
                                        <Text>Professional Chauffeurs</Text>
                                    </div>
                                </div>
                            </div>

                        </Col>

                        <Col md={12} sm={24}>
                            <img
                                src={Image}
                                alt="a sport car"
                                style={{ width: '100%', borderRadius: 8 }}
                                loading="lazy"
                            />
                        </Col>
                    </Row>
                </div>

                {/* Services Section */}
                <div style={{ padding: '60px 20px', backgroundColor: '#fafafa', textAlign: 'center' }}>
                    <Title level={4} style={{ color: '#faad14' }}>See our</Title>
                    <Title level={2}>Popular Services</Title>
                    <Row gutter={24} justify="center" style={{ marginTop: 40 }}>
                        <Col xs={24} sm={12} md={8}>
                            <Card bordered hoverable>
                                <EnvironmentOutlined style={{ fontSize: 40, color: '#faad14' }} />
                                <Title level={4}>Airport Transfers</Title>
                                <Paragraph>Timely and smooth pickups and drop-offs to and from the airport.</Paragraph>
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Card bordered hoverable>
                                <CarOutlined style={{ fontSize: 40, color: '#faad14' }} />
                                <Title level={4}>Private Events & Proms</Title>
                                <Paragraph>Arrive in style to your prom, party, or private gathering.</Paragraph>
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Card bordered hoverable>
                                <HomeOutlined style={{ fontSize: 40, color: '#faad14' }} />
                                <Title level={4}>Weddings & Celebrations</Title>
                                <Paragraph>Make your big day extra special with our luxury limos.</Paragraph>
                            </Card>
                        </Col>
                    </Row>
                </div>

                {/* Testimonial Section */}
                <div style={{ padding: '80px 20px', maxWidth: 1000, margin: '0 auto', textAlign: 'center' }}>
                    <Title level={2}>What Our Clients Say</Title>
                    <Carousel autoplay dotPosition="bottom">
                        {testimonials.map((t, index) => (
                            <div key={index}>
                                <Card style={{ margin: '40px auto', maxWidth: 600 }}>
                                    <Paragraph>"{t.text}"</Paragraph>
                                    <Avatar src={t.avatar} />
                                    <Text strong> &nbsp;{t.name}</Text>
                                </Card>
                            </div>
                        ))}
                    </Carousel>
                </div>

                {/* Blog Section */}
                <div style={{ padding: '60px 20px', backgroundColor: '#f0f2f5' }}>
                    <Title level={2} style={{ textAlign: 'center' }}>Latest From Our Blog</Title>
                    <BlogList />
                </div>
            </Content>

            {/* Footer */}
            <Footer style={{ background: '#001f5b', color: '#ffffff', padding: '60px 20px 40px' }}>
                <Row gutter={[32, 32]} justify="space-between" style={{ maxWidth: 1200, margin: '0 auto' }}>
                    {/* Company Info Section */}
                    <Col xs={24} sm={12} md={8}>
                        <Title level={4} style={{ color: '#ffffff' }}>LuxuryLife Limo</Title>
                        <Paragraph style={{ color: '#d6d6d6', fontSize: '16px' }}>
                            Premium limo and car rental services tailored for elegance, comfort, and punctuality.
                            Travel in style with our professional chauffeurs and luxury fleet.
                        </Paragraph>
                    </Col>

                    {/* Contact Us Section */}
                    <Col xs={24} sm={12} md={8}>
                        <Title level={5} style={{ color: '#ffffff', fontSize: '18px', fontWeight: 600 }}>Contact Us</Title>
                        <Space direction="vertical" size="middle" style={{ color: '#ffffff' }}> {/* Set color to white */}
                            <Text style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '16px', color: 'white' }}>
                                <MailOutlined style={{ color: '#ffffff' }} /> luxurylifelimo@yahoo.com
                            </Text>
                            <Text style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '16px', color: 'white' }}>
                                <PhoneOutlined style={{ color: '#ffffff' }} /> +1 (470) 696-4956
                            </Text>
                            <Text style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '16px', color: 'white' }}>
                                <EnvironmentOutlined style={{ color: '#ffffff' }} /> Rex, GA by the Atlanta Airport
                            </Text>
                            <Text
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    fontSize: '16px',
                                    color: 'white',
                                }}
                            >
                                <span style={{ fontWeight: 'bold', color: '#ffffff' }}>IG:</span>
                                <a
                                    href="https://www.instagram.com/luxury_lifelimo/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#ffffff', textDecoration: 'underline' }}
                                >
                                    @luxury_lifelimo
                                </a>
                            </Text>

                        </Space>
                    </Col>

                    {/* Location Map Section (Larger Map) */}
                    <Col xs={24} sm={24} md={8}>
                        <Title level={5} style={{ color: '#ffffff', fontSize: '18px', fontWeight: 600 }}>Our Location</Title>
                        <div style={{
                            borderRadius: 8, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                            height: '400px' // Increased height for a larger map
                        }}>
                            <iframe
                                title="LuxuryLife Limo Location"
                                src="https://www.google.com/maps/embed?..."
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                            ></iframe>
                        </div>
                    </Col>
                </Row>

                {/* Footer Bottom */}
                <div style={{ textAlign: 'center', marginTop: 40, borderTop: '1px solid #2d3c65', paddingTop: 20 }}>
                    <Text style={{ color: '#ccc', fontSize: '14px' }}>&copy; 2025 LuxuryLife Limo. All rights reserved.</Text>
                </div>
            </Footer>

        </Layout>
    );
};

export default Limo;
